export default "/static/1647e575337697f7.png"